export default {
    READYTOSTART: 0,
    READYFORNEXT: 1,
    BUSY: 2,
    ENDED: 3
};
